import { useState, useRef, useEffect } from "react";
import { cn } from "../lib/utils";

type PopoverSide = "top" | "bottom" | "left" | "right";

interface PopoverProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  side?: PopoverSide;
  className?: string;
}

export function Popover({ trigger, children, side = "bottom", className }: PopoverProps) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onDown(e: MouseEvent) {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div ref={rootRef} className={cn("popover-root", className)}>
      <div
        className="popover-trigger"
        onClick={() => setOpen(v => !v)}
      >
        {trigger}
      </div>
      {open && (
        <div className={cn("popover-content", `popover-${side}`)}>
          {children}
        </div>
      )}
    </div>
  );
}
